export default __webpack_public_path__ + "static/media/tieuchuan.2609ba46.png";